import React from 'react';

import { Field, Formik } from 'formik';
import { Grid } from 'semantic-ui-react';

import {
  Button,
  Header,
  Text,
  InputFormField,
  Toggle,
} from '@playbookux/playbook-web-core';
import Dropdown from '../../layout-components/dropdown';
import SearchField from '../../layout-components/search';
import ComponentWithSource from './component-with-source';

import {
  Container,
  ContainerContent,
} from './styles';

const RenderingStyleGuide = () => (
  <Container>
    <Header>Style Guide</Header>

    <Grid columns={2}>
      <Grid.Row>
        <Grid.Column>
          <Header>Headers</Header>
          <ContainerContent>
            <ComponentWithSource
              Component={<Header as="h1">Heading 1</Header>}
              source={`import { Header } from '@playbookux/playbook-web-core';
<Header as="h1">Heading 1</Header>`}
            />
            <ComponentWithSource
              Component={<Header as="h2">Heading 2</Header>}
              source={`import { Header } from '@playbookux/playbook-web-core';
<Header as="h2">Heading 1</Header>`}
            />
            <ComponentWithSource
              Component={<Header as="h3">Heading 3</Header>}
              source={`import { Header } from '@playbookux/playbook-web-core';
<Header as="h3">Heading 1</Header>`}
            />
            <ComponentWithSource
              Component={<Header as="h4">Heading 4</Header>}
              source={`import { Header } from '@playbookux/playbook-web-core';
<Header as="h4">Heading 4</Header>`}
            />
            <ComponentWithSource
              Component={<Header.Danger>Warning Header</Header.Danger>}
              source={`import { Header } from '@playbookux/playbook-web-core';
<Header.Danger>Warning Header</Header.Danger>`}
            />
          </ContainerContent>

          <Header>Link</Header>
          <ContainerContent>
            <ComponentWithSource
              Component={<a>This is a link</a>}
              source="<a>This is a link</a>"
            />
          </ContainerContent>

          <Header>Text</Header>
          <ContainerContent>
            <ComponentWithSource
              Component={(
                <Text>
                  Text Primary
                  <br />
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </Text>
              )}
              source={`import { Text } from '@playbookux/playbook-web-core';
<Text>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Text>`}
            />
            <ComponentWithSource
              Component={(
                <Text.Secondary>
                  Text Secondary
                  <br />
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </Text.Secondary>
              )}
              source={`import { Text } from '@playbookux/playbook-web-core';
<Text.Secondary>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Text.Secondary>`}
            />
            <ComponentWithSource
              Component={(
                <Text.Bold>
                  Text Bold
                  <br />
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </Text.Bold>
              )}
              source={`import { Text } from '@playbookux/playbook-web-core';
<Text.Bold>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Text.Bold>`}
            />
            <ComponentWithSource
              Component={(
                <Text.Muted>
                  Text Muted
                  <br />
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </Text.Muted>
              )}
              source={`import { Text } from '@playbookux/playbook-web-core';
<Text.Muted>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Text.Muted>`}
            />
            <ComponentWithSource
              Component={(
                <Text.Error>
                  Text Error
                  <br />
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </Text.Error>
              )}
              source={`import { Text } from '@playbookux/playbook-web-core';
<Text.Error>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Text.Error>`}
            />
          </ContainerContent>

          <Header>Buttons</Header>
          <ContainerContent>
            <ComponentWithSource
              Component={<Button>Primary button</Button>}
              source={`import { Button } from '@playbookux/playbook-web-core';
<Button>Primary button</Button>`}
            />
            <ComponentWithSource
              Component={<Button.Inverted>Secondary button</Button.Inverted>}
              source={`import { Button } from '@playbookux/playbook-web-core';
<Button.Inverted>Secondary button</Button.Inverted>`}
            />
            <ComponentWithSource
              Component={<Button.Danger>Danger button</Button.Danger>}
              source={`import { Button } from '@playbookux/playbook-web-core';
<Button.Danger>Danger button</Button.Danger>`}
            />
          </ContainerContent>
        </Grid.Column>
        <Grid.Column>
          <Header>Input</Header>
          <ContainerContent>
            <ComponentWithSource
              Component={(
                <Formik initialValues={{ field: '' }}>
                  <Field
                    placeholder="Regular Input field - This is a placeholder"
                    name="field"
                    component={InputFormField}
                  />
                </Formik>
              )}
              source={`import { Field, Formik } from 'formik';
import { InputFormField } from '@playbookux/playbook-web-core';

<Formik initialValues={{ field: '' }}>
  <Field placeholder="This is a placeholder" name="field" component={InputFormField} />
</Formik>`}
            />
            <ComponentWithSource
              Component={<SearchField placeholder="Search field - This is a placeholder" />}
              source={`import SearchField from '.../core/layout-components/search';
<SearchField placeholder="This is a placeholder" />`}
            />
          </ContainerContent>
          <ContainerContent>
            <Header>Dropdown</Header>
            <ComponentWithSource
              Component={(
                <Dropdown
                  scrolling
                  inline
                  header="header"
                  options={[{
                    key: 'item1',
                    text: 'item1',
                    value: 'item1',
                    active: false,
                  }]}
                  value="item1"
                />
              )}
              source={`import Dropdown from '.../core/layout-components/dropdown';
<Dropdown scrolling inline header="Dropdown header" options={options}/>`}
            />
          </ContainerContent>
          <ContainerContent>
            <Header>Toggle</Header>
            <ComponentWithSource
              Component={(
                <Toggle
                  id="ToggleComponent"
                />
              )}
              source={`import { Toggle } from '@playbookux/playbook-web-core';
<Toggle onChange={() => {}} id="ToggleComponent" checked />`}
            />
          </ContainerContent>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Container>
);

export default RenderingStyleGuide;
